"use client";

import { createContext, useContext } from "react";

/**
 * True when the surrounding `RefSections` band renders on the page-wide body
 * grid (transparent background, grid-paper layout) instead of the opaque warm
 * band. Sections and kit primitives read this to switch to grid-aligned
 * layout + `GridClearing` (see CLAUDE.md "Grid system").
 */
export const RefGridContext = createContext(false);

export const useRefGridMode = () => useContext(RefGridContext);
